import Vue from "vue";
import {getLanguage, translate} from "./i18n.js";
import {getMarketIcon} from "./utils.js";
import env from "../../src/env.mjs";
import Network from "./Network.js";

function isCurrentURILocal() {
    return window.location.protocol !== `capacitor:` &&
        (window.location.host.indexOf(`localhost:`) === 0 ||
        window.location.hostname.indexOf(`127.0.0.1`) === 0 ||
        window.location.hostname.indexOf(`192.168.`) === 0 ||
        window.location.hostname.indexOf(`10.0.`) === 0);
}

const envName = localStorage.getItem(`env`);
if (envName && env.hasOwnProperty(envName)) {
    window.env = env[envName];
} else {
    if (isCurrentURILocal()) {
        window.env = env.local;
        localStorage.setItem(`env`, `local`);
    } else if (window.location.hostname.indexOf(`dev.`) === 0) {
        window.env = env.dev;
        localStorage.setItem(`env`, `dev`);
    } else if (window.location.hostname.indexOf(`demo.`) === 0) {
        window.env = env.demo;
        localStorage.setItem(`env`, `demo`);
    } else {
        window.env = env.live;
        localStorage.setItem(`env`, `live`);
    }
}

Vue.mixin({
    data() {
        return {
            console: console,
            document: document,
            window: window
        }
    },
    computed: {
        isMobileLayout() {
            return this.$store.state.isMobileLayout;
        },
        isSmallLayout() {
            return this.$store.state.isSmallLayout;
        },
        isTabletLayout() {
            return this.$store.state.isTabletLayout;
        },
        isMobileOrTabletLayout() {
            return this.$store.state.isMobileOrTabletLayout;
        },
        isLargeLayout() {
            return this.$store.state.isLargeLayout;
        },
        isExtraLargeLayout() {
            return this.$store.state.isExtraLargeLayout;
        },
        language() {
            return getLanguage();
        },
        printMode() {
            return this.$store.state.printMode;
        },
        appApiUrl() {
            if (window.location.hostname.indexOf(`192.168.`) >= 0) {
                const apiPort = /:(\d{2,4})/g.exec(window.env.VUE_APP_API_URL)[1];
                return `${window.location.protocol}//${window.location.hostname}:${apiPort}`;
            } else {
                return window.env.VUE_APP_API_URL;
            }
        }
    },
    activated() {
        if (`serviceWorker` in navigator) {
            navigator.serviceWorker.getRegistration().then(registration => {
                if (registration) {
                    registration.update();
                }
            });
        }
    },
    created() {
        // this.onWindowResize();
        // // No choice but to update manually here, the window properties are not reactive
        // window.addEventListener(`resize`, this.onWindowResize);
    },
    methods: {
        getLayoutWidth() {
            return window.getLayoutWidth();
        },
        onWindowResize() {
            this.isMobileLayout = window.isMobileLayout;
            this.isSmallLayout = window.isSmallLayout;
            this.isTabletLayout = window.isTabletLayout;
            this.isMobileOrTabletLayout = window.isMobileOrTabletLayout;
            this.isLargeLayout = window.isLargeLayout;
            this.isExtraLargeLayout = window.isExtraLargeLayout;
        },
        showInvalidFields() {
            this.$swal({
                title: this.tr(`Invalid fields|Champs non valides`),
                text: this.tr(`Some fields are missing or invalid|Certains champs sont manquant ou non valides`),
                icon: `info`
            });
        },
        showLoading(title, text, percent) {
            text = text || this.tr(`Please wait...|Merci de patienter...`);
            let content = null;
            if (percent) {
                content = document.createElement(`div`);
                content.className = `progress sm`;
                let progress = document.createElement(`div`);
                progress.className = `progress-bar`;
                progress.style.width = percent + `%`;
                content.appendChild(progress);
            }
            this.$swal({
                title: title || this.tr(`In progress|En cours`),
                text: text,
                content: content,
                icon: `https://eyeinlivestorage.blob.core.windows.net/public/icons/loading.gif`,
                closeOnEsc: false,
                closeOnClickOutside: false,
                buttons: false
            });
        },
        showErrorMessage(title, text) {
            this.$swal({
                title: title || this.tr(`Hmm|Hmm`),
                text: text || this.tr(`Something wrong happened...|Quelque chose d'inattendu s'est produit...`),
                icon: `error`
            });
        },
        hideLoading() {
            this.$swal.close();
        },
        showSavedMessage(title, text, callback) {
            this.$swal({
                title: title || this.tr(`Saved|Enregistré`),
                text: text || null,
                icon: `success`
            }).then(() => {
                if (typeof callback === `function`) {
                    callback();
                }
            });
        },
        showToast(title) {
            this.$bvToast.toast(` `, {
                title: this.tr(title),
                variant: `simple`,
                autoHideDelay: 3000,
                noCloseButton: true
            });
        },
        showSavedToast() {
            this.showToast(`Saved|Enregistré`);
        },
        tr(values) {
            return translate(values);
        },
        hasPermission(permission) {
            return localStorage.getItem(permission) && localStorage.getItem(permission).trim() === `yes`;
        },
        removeTz(value) {
            if (!value)
                return value;
            return value.replace(/\.\d{3}Z/g, ``);
        },
        getLanguage: getLanguage,
        getEnv() {
            return window.env.VUE_APP_ENV;
        },
        switchEnvironment(envName, reload = true) {
            if (env.hasOwnProperty(envName)) {
                window.env = env[envName];
                localStorage.setItem(`env`, envName);
            } else {
                window.env = env.live;
                localStorage.setItem(`env`, `live`);
            }

            if (reload) {
                window.location.reload()
            } else {
                Network.init();
            }
        },
        switchToLocal(reload = true) {
            this.switchEnvironment(`local`, reload);
        },
        switchToDev(reload = true) {
            this.switchEnvironment(`dev`, reload);
        },
        switchToDemo(reload = true) {
            this.switchEnvironment(`demo`, reload);
        },
        switchToLive(reload = true) {
            this.switchEnvironment(`live`, reload);
        },
        isCurrentURILocal() {
            return isCurrentURILocal();
        },
        isLocal() {
            return this.getEnv() === `local`;
        },
        isDev() {
            return this.getEnv() === `dev`;
        },
        isLive() {
            return this.getEnv() === `live`;
        },
        isDemo() {
            return this.getEnv() === `demo`;
        },
        isNext() {
            return this.getEnv() === `next`;
        },
        getPublicIcon(name) {
            return `https://eyeinlivestorage.blob.core.windows.net/public/icons/ui/${name}.png`;
        },
        getPublicImage(path) {
            return `https://eyeinlivestorage.blob.core.windows.net/public/eye-intelligence` + path;
        },
        getStorageUrl(path) {
            if (this.isLive() || this.isNext()) {
                return `https://eyeinlivestorage.blob.core.windows.net` + (path || ``);
            } else {
                return `https://eyeindevstorage.blob.core.windows.net` + (path || ``);
            }
        },
        getMarketIcon: getMarketIcon
    }
});
